var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['rb-unselected-warn', { 'rb-active': _vm.showNotice }]},[_vm._v(" Please make a selection to move to the next step ")])
}
var staticRenderFns = []

export { render, staticRenderFns }